<template>
    <div class="modal login-panel right" id="loginpanel">
        <div class="close-button"><span class="icon-cross"></span>Fermer</div>

        <transition name="slide-fade" mode="out-in">
            <h2 class="titre" :key="login">{{ login ? 'Connexion' : 'Inscription' }}</h2>
        </transition>
        <p class="require-for-post" v-if="issocialwall">
            Vous devez être connecté pour pouvoir publier votre photo
        </p>
        <p class="require-for-post" v-else-if="iswishlist">
            Vous devez être connecté pour pouvoir mettre une croisière dans vos favoris
        </p>
        <p class="require-for-post" v-else-if="isoption">
            Vous devez être connecté pour pouvoir poser une option
        </p>
        <p class="require-for-post" v-else></p>
        <div class="content mCustomScrollbar">

            <!--ScrollBar-->
            <transition name="slide-fade" mode="out-in">
                <div v-if="login" key="login">
                    <p class="sous-titre">J'ai déjà un compte</p>
                    <login-form :isoption="isoption"></login-form>
                    <p class="lostpassword"><a href="#" @click.prevent="goToLostPassword()">Mot de passe oublié ?</a></p>
                    <p class="margin"></p>
                    <p>
                        <a href="#" @click.prevent="login = false" class="no-account">
                            Vous n'avez pas de compte ? Cliquez ici pour en créer un.
                        </a>
                    </p>
                </div>
                <div v-else key="register">
                    <p class="sous-titre">Créer un compte</p>
                    <register-form :isoption="isoption"></register-form>
                    <p class="margin"></p>
                    <p>
                        <a href="#" @click.prevent="login = true" class="no-account">
                            Vous avez déjà un compte ? Cliquez ici pour vous connecter.
                        </a>
                    </p>
                </div>
            </transition>

        </div>
    </div>
</template>

<script>
    import LoginForm from './LoginForm';
    import RegisterForm from './RegisterForm';

    export default {
        components: {LoginForm, RegisterForm},
        data() {
            return {
                login: true,
                issocialwall: false,
                iswishlist: false,
                isoption: false,
            };
        },
        methods:{
            goToLostPassword(){
                window.location = GrandsEspaces.lostpassword_url;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/LoginPanel.vue